import { useState, useContext, useEffect } from 'react';
import { Link } from 'react-router-dom';
import AuthContext from '../../context/autenticacion/authContext.js';
import Loading from '../Modales/Loading';
import AuthShell, { Aviso, OK_RE } from './AuthShell';
import { useT } from 'i18n';

const CONFIRMAR = 'El usuario debe confirmar la dirección de correo electrónico.';

const Login = (props) => {
  const { t, ts } = useT();
  const { mensaje, autenticado, iniciarSesion, Limpiar, resendCorreo, status, usuario, demo_status,
    BtnProtectOff, PantherLoad, PantherNoLoad, PantherNoLoadAppRecarga, ultimos_movimientos } = useContext(AuthContext);

  const [datos, setDatos] = useState({ email: '', password: '' });
  const [ver, setVer] = useState(false);
  const [error, setError] = useState('');
  const [enviando, setEnviando] = useState(false);
  const { email, password } = datos;
  const [sesionCerrada] = useState(() => {
    try { const v = sessionStorage.getItem('p7_sesion_cerrada'); sessionStorage.removeItem('p7_sesion_cerrada'); return !!v; } catch (e) { return false; }
  });

  useEffect(() => {
    if (usuario && autenticado && status && ultimos_movimientos) {
      props.history.push('/cliente');
      PantherNoLoad();
      PantherNoLoadAppRecarga();
      BtnProtectOff();
    }
  }, [usuario, autenticado, status, ultimos_movimientos, props.history, PantherNoLoad, PantherNoLoadAppRecarga, BtnProtectOff]);

  useEffect(() => { if (mensaje) setEnviando(false); }, [mensaje]);
  useEffect(() => () => { if (Limpiar) Limpiar(); }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const cambiar = (e) => {
    const { name, value } = e.target;
    setDatos((d) => ({ ...d, [name]: value }));
    setError('');
    if (mensaje) Limpiar();
  };

  const entrar = (e) => {
    e.preventDefault();
    if (!email.trim() || !password) return;
    if (password.length < 6) { setError(t('login.claveCorta')); return; }
    setEnviando(true);
    window.scrollTo(0, 0);
    PantherLoad();
    iniciarSesion({ email, password });
  };

  const reenviar = () => { if (email.trim()) resendCorreo({ email }); };

  const sinConfirmar = mensaje === CONFIRMAR;

  return (
    <>
      <Loading />
      <AuthShell titulo={t('login.titulo')} subtitulo={t('login.subtitulo')} demo={demo_status === 'active'}>
        {sinConfirmar && (
          <Aviso texto={t('login.confirmaTitulo')}>
            <small>{t('login.confirmaAyuda')}</small>
            <div style={{ marginTop: '.6rem' }}>
              <button type="button" className="p7a-btn ghost" onClick={reenviar} disabled={!email.trim()}>{t('login.reenviar')}</button>
              {!email.trim() && <small>{t('login.escribeCorreo')}</small>}
            </div>
          </Aviso>
        )}
        {mensaje && !sinConfirmar && (
          <Aviso texto={ts(mensaje)} ok={OK_RE.test(mensaje)}>
            {mensaje === 'Intente nuevamente.' && <small>{t('login.unaSesion')}</small>}
          </Aviso>
        )}
        {sesionCerrada && !mensaje && (
          <Aviso texto={t('login.sesionCerradaTitulo')}>
            <small>{t('login.sesionCerradaAyuda')}</small>
          </Aviso>
        )}
        {error && <Aviso texto={error} />}

        <form onSubmit={entrar} noValidate={false}>
          <div className="p7a-campo">
            <label htmlFor="email">{t('login.correo')}</label>
            <input id="email" name="email" type="email" placeholder={t('login.correoEjemplo')} value={email} onChange={cambiar} required autoComplete="username" />
          </div>
          <div className="p7a-campo">
            <label htmlFor="password">{t('login.clave')}</label>
            <div className="p7a-clave">
              <input id="password" name="password" type={ver ? 'text' : 'password'} value={password} onChange={cambiar} required autoComplete="current-password" />
              <button type="button" onClick={() => setVer(!ver)}>{ver ? t('login.ocultar') : t('login.mostrar')}</button>
            </div>
          </div>
          <button type="submit" className="p7a-btn" disabled={!!usuario || enviando}>{enviando ? t('login.entrando') : t('login.entrar')}</button>
        </form>

        <div className="p7a-links">
          <Link to="/forgot">{t('login.olvido')}</Link>
          <span>{t('login.sinCuenta')} <Link to="/nueva-cuenta">{t('login.crear')}</Link></span>
        </div>
        <p className="p7a-nota">{t('login.nota')}</p>
      </AuthShell>
    </>
  );
};

export default Login;
